import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const raisons = [
  "Sangle ou manivelle usante, difficile à actionner",
  "Volet dur à manœuvrer, surtout en hauteur",
  "Envie de confort sans remplacer tout le volet",
];

export default function Signes() {
  return (
    <section className="bg-[#F5F2EB] py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-[#1B2A4A] text-2xl md:text-3xl font-extrabold mb-5">
              Pourquoi électrifier avec un moteur Nice
            </h2>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-6">
              Les moteurs Nice se distinguent par leur robustesse et leur fiabilité sur le long terme. Si vous avez un volet manuel lourd ou une grande baie vitrée, le moteur Nice Roll ou Era offre un couple de démarrage supérieur aux motorisations d'entrée de gamme. Le récepteur radio intégré dans le moteur lui-même réduit la complexité de l'installation et libère de l'espace dans le coffre, ce qui est un avantage décisif dans les anciennes constructions alsaciennes où le coffre est étroit.
            </p>
            <ul className="space-y-3 mb-8">
              {raisons.map((raison) => (
                <li key={raison} className="flex items-center gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-[#E8734A]/10 shrink-0">
                    <i className="ri-check-line text-[#E8734A] text-sm"></i>
                  </span>
                  <span className="text-[#1B2A4A] text-base font-medium">{raison}</span>
                </li>
              ))}
            </ul>

            <a
              href="tel:0374473240"
              className="flex items-center gap-2 bg-[#E8734A] text-white px-6 py-4 rounded-full font-semibold text-base hover:bg-[#E8734A]/90 transition-colors whitespace-nowrap mx-auto"
            >
              <i className="ri-phone-line text-lg"></i>
              Appeler le 03 74 47 32 40
            </a>
          </div>

          <div className="order-1 lg:order-2 relative rounded-2xl overflow-hidden">
            <ImagePlaceholder src="https://readdy.ai/api/search-image?query=Modern%20French%20living%20room%20with%20a%20motorized%20Nice%20roller%20shutter%20being%20controlled%20by%20a%20remote%20from%20a%20comfortable%20sofa%20warm%20interior%20lighting%20cozy%20atmosphere%20clean%20professional%20photography%20neutral%20tones%20Alsace%20home&width=700&height=520&seq=elec-nice-signes&orientation=landscape" alt="Volet motorisé Nice commandé par télécommande" className="w-full h-[340px] md:h-[420px]" loading="lazy" />
          </div>
        </div>
      </div>
    </section>
  );
}